
/**
 *
 * @param {string} hostDomain
 * @param {string} tenant
 * @returns {string}
 */
export const getTenantAssetsDir = (hostDomain, tenant) => `${hostDomain}/assets/tenants/${tenant}`;

/**
 *
 * @param {string} hostDomain
 * @param {string} micrositeId
 * @param {string} tenant
 * @returns {string}
 */
export const getMicrositeTenantAssetsDir = (hostDomain, micrositeId, tenant) => `${hostDomain}/assets/microsites/${micrositeId}/${tenant}`;
